"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeedDownButton = SpeedDownButton;
const preact_1 = require("preact");
const typestyle_1 = require("typestyle");
const style_1 = require("./style");
const Controls_style_1 = require("../../Controls.style");
function SpeedDownButton(props) {
    return ((0, preact_1.h)("div", { class: (0, typestyle_1.classes)(Controls_style_1.ControlsStyle.button, style_1.SpeedDownButtonStyle.button), onClick: props.onClick },
        (0, preact_1.h)("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "currentcolor" },
            (0, preact_1.h)("path", { d: "M0 0 L0 64 L32 32 L32 64 L64 32 L32 0 L32 32 Z" }))));
}
